import BaseModel from "./BaseModel";
import {EFormElementInputType} from "../enums/EFormElementInputType";
import {EFormElementType} from "../enums/EFormElementType";

export default class FormElement extends BaseModel {
  private _title: string = "";
  private _name: string = "";
  private _class: string = "";
  private _type: EFormElementInputType = EFormElementInputType.Text;
  private _custom_class: string = "";
  private _placeholder: string = "";
  private _label_text: string = "";
  private _label_class: string = "";
  private _options: string = "";
  private _parent: number = -1;
  private _form_id: number = -1;
  private _value: string = "";
  private _required: boolean = false;
  private _checked: boolean = false;
  private _element: EFormElementType = EFormElementType.Input;
  private _item_order: number = 0;

  get title (): string {
    return this._title;
  }

  set title (value: string) {
    this._title = value;
  }

  get name (): string {
    return this._name;
  }

  set name (value: string) {
    this._name = value;
  }

  get class (): string {
    return this._class;
  }

  set class (value: string) {
    this._class = value;
  }

  get type (): EFormElementInputType {
    return this._type;
  }

  set type (value: EFormElementInputType) {
    this._type = value;
  }

  get custom_class (): string {
    return this._custom_class;
  }

  set custom_class (value: string) {
    this._custom_class = value;
  }

  get placeholder (): string {
    return this._placeholder;
  }

  set placeholder (value: string) {
    this._placeholder = value;
  }

  get labelText (): string {
    return this._label_text;
  }

  set label_text (value: string) {
    this._label_text = value;
  }

  get options (): string {
    return this._options;
  }

  set options (value: string) {
    this._options = value;
  }

  get parent (): number {
    return this._parent;
  }

  set parent (value: number) {
    this._parent = value;
  }

  get form_id (): number {
    return this._form_id;
  }

  set form_id (value: number) {
    this._form_id = value;
  }

  get required (): boolean {
    return this._required;
  }

  set required (value: boolean) {
    this._required = value;
  }

  get checked (): boolean {
    return this._checked;
  }

  set checked (value: boolean) {
    this._checked = value;
  }

  get element (): EFormElementType {
    return this._element;
  }

  set element (value: EFormElementType) {
    this._element = value;
  }

  get item_order (): number {
    return this._item_order;
  }

  set item_order (value: number) {
    this._item_order = value;
  }

  get value (): string {
    return this._value;
  }

  set value (value: string) {
    this._value = value;
  }

  get label_class (): string {
    return this._label_class;
  }

  set label_class (value: string) {
    this._label_class = value;
  }
}
